import { Input ,Component, Output, EventEmitter } from '@angular/core';
import { OnboardingStatus, StatusItem } from 'src/app/models/AgentModel';
type StatusType = 'Completed' | 'In Progress' | 'Pending';
@Component({
  selector: 'app-agent-status',
  templateUrl: './agent-status.component.html',
  styleUrls: ['./agent-status.component.css']
})

export class AgentStatusComponent {
  @Output() downloadCertificate = new EventEmitter();
  @Input() data:OnboardingStatus = {
    ADR_Status : 0,
    BNK_Status : 0,
    EXM_Status : 0,
    IMG_Status : 0,
    KYC_Status : 0,
    PAN_Status : 0,
    QUL_Status : 0,
    TRN_Status : 0,
    TrainingSession1 : 0,
    TrainingSession2 : 0,
    TrainingSession3 : 0,
    TrainingSession4 : 0,
    TrainingSession5 : 0  
  };

  kycItems:StatusItem[]=[
    {title:'Aadhaar',key:'ADR_Status'},
    {title:'PAN',key:'PAN_Status'},
    {title:'Qualification',key:'QUL_Status'},
    {title:'Photo',key:'IMG_Status'}
  ];

  trainingItems:StatusItem[]=[
    {title:'Session 1',key:'TrainingSession1'},
    {title:'Session 2',key:'TrainingSession2'},
    {title:'Session 3',key:'TrainingSession3'},
    {title:'Session 4',key:'TrainingSession4'},
    {title:'Session 5',key:'TrainingSession5'}
  ];

  ngOnInit():void{

    // Replace this with your API response

    // this.data={
    //   ADR_Status:1,
    //   PAN_Status:1,
    //   QUL_Status:1,
    //   IMG_Status:1,
    //   BNK_Status:1,
    //   KYC_Status:1,
    //   TRN_Status:2,
    //   EXM_Status:0,
    //   TrainingSession1:1,
    //   TrainingSession2:1,
    //   TrainingSession3:2,
    //   TrainingSession4:0,
    //   TrainingSession5:0
    // };

  }


  getStatus(status:number){

    switch(status){

      case 1:
        return 'Completed';

      case 2:
        return 'In Progress';

      default:
        return 'Pending';

    }

  }

  getClass(status:number= 0){

    switch(status){

      case 1:
        return 'completed';

      case 2:
        return 'in-progress';

      default:
        return 'pending';

    }

  }

  getIcon(status:number = 0){

    switch(status){

      case 1:
        return '✔';

      case 2:
        return '🟡';

      default:
        return '⏳';

    }

  }


  get progress(){
    debugger;
    let dd = this.data;
    const values=[
      // this.data?.ADR_Status,
      // this.data?.PAN_Status,
      // this.data?.QUL_Status,
      // this.data?.IMG_Status,
      this.data?.BNK_Status,
      this.data?.TRN_Status,
      this.data?.EXM_Status,
      this.data?.KYC_Status
    ];

    let score=0;

    values.forEach(x=>{
      if(x===1)
        score+=1;

      else if(x===2)
        score+=0.5;
    });
    return Math.round(score/values.length*100);
  }

  async download(){
    this.downloadCertificate.emit();
  }

}

// interface OnboardingStatus {

//   ADR_Status: number;
//   PAN_Status: number;
//   QUL_Status: number;
//   IMG_Status: number;
//   BNK_Status: number;
//   KYC_Status: number;
//   TRN_Status: number;
//   EXM_Status: number;

//   // TrainingEndAt: string;
//   // ExamEndAt: string;

//   TrainingSession1: number;
//   TrainingSession2: number;
//   TrainingSession3: number;
//   TrainingSession4: number;
//   TrainingSession5: number;
// }

// interface StatusItem{
//   title:string;
//   key:keyof OnboardingStatus;
// }